const capitalLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const lowercaseLetters = 'abcdefghijklmnopqrstuvwxyz'
const numbers = '0123456789'
// TODO 暂时去掉下划线验证
const specialCharacters = '~!@#$%^&*()_+`-={}:";\'<>?,./|[]\\'
// 用于正则的字符串，需要特殊处理字符包含\-[]，这些字符前面需要加\
let regexpSpecialCharacters = specialCharacters
regexpSpecialCharacters = regexpSpecialCharacters.replace('\\', '\\\\')
regexpSpecialCharacters = regexpSpecialCharacters.replace('-', '\\-')
regexpSpecialCharacters = regexpSpecialCharacters.replace('[', '\\[')
regexpSpecialCharacters = regexpSpecialCharacters.replace(']', '\\]')

const randomCharacter = characters => {
  return characters[Math.floor(Math.random() * characters.length)]
}

export default {
  generatePassword () {
    let password = ''
    for (let i = 0; i < 2; ++i) {
      password += randomCharacter(capitalLetters)
      password += randomCharacter(lowercaseLetters)
      password += randomCharacter(numbers)
      password += randomCharacter(specialCharacters)
    }
    return password
  },
  /**
   * 测试密码强度，0-4级
   * @param password
   * @returns {number}
   */
  testPasswordLevel (password) {
    let level = 0
    new RegExp(`[${capitalLetters}]+`).test(password) && ++level
    new RegExp(`[${lowercaseLetters}]+`).test(password) && ++level
    new RegExp(`[${numbers}]+`).test(password) && ++level
    new RegExp(`[${regexpSpecialCharacters}]+`).test(password) && ++level
    return level
  }
}

export const publicKey = `MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAIDPc1YtVpNn63BXTNOWoUJ8WaCb+4p6q2mkpqnuaDDDeFOqG9qdow2u84Rb90E/dNJPsMdqluo835DC4lbJW7ECAwEAAQ==`



// WEBPACK FOOTER //
// ./src/utils/password.js